module.exports = __webpack_public_path__ + "static/media/test.c8ac2a00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/test.jpg
// module id = 795
// module chunks = 0